import type { TranslationDictionary } from "./types";

export const HI_DICTIONARY: TranslationDictionary = {
    "app.newTask": "नया",
    "app.newTaskAria": "नई चैट",
    "sidebar.searchPlaceholder": "प्रॉम्प्ट या कार्य ID खोजें",
    "sidebar.filters": "कार्य फ़िल्टर",
    "sidebar.allRatios": "सभी अनुपात",
    "sidebar.allOrientations": "सभी झुकाव",
    "sidebar.allModes": "सभी मोड",
    "sidebar.allResolutions": "सभी रिज़ॉल्यूशन",
    "sidebar.activeTasks": "सक्रिय कार्य",
    "sidebar.topAnchors": "शीर्ष समय नेविगेशन",
    "sidebar.bottomAnchors": "निचला समय नेविगेशन",
    "sidebar.resize": "साइडबार का आकार बदलें",
    "batch.selected": "0 चयनित",
    "batch.selectedCount": "{count} चयनित",
    "batch.archivedCount": "संग्रहीत {count} चैट",
    "batch.archiveFailed": "बैच संग्रह विफल रहा",
    "batch.runningCannotDeleteSelected": "चयनित चैट चल रही हैं और उन्हें हटाया नहीं जा सकता",
    "batch.deleteTitle": "{count} चैट हटाएं?",
    "batch.deleteMessage": "इससे स्थानीय चित्र फ़ाइलें भी हट जाएंगी.",
    "batch.deleteSkippedDetail": "{count} चालू कार्य रखे जायेंगे",
    "batch.deleteSkippedSuffix": ", {count} चल रहे कार्य हटाए नहीं गए",
    "batch.deletedCount": "हटाई गई {count} चैट{skipped}",
    "batch.deleteFailed": "बैच हटाना विफल रहा",
    "action.archive": "संग्रहित करें",
    "action.delete": "हटाएँ",
    "action.cancel": "रद्द करें",
    "action.edit": "संपादित करें",
    "action.clear": "साफ़ करें",
    "action.paste": "चिपकाएँ",
    "action.find": "खोजें",
    "action.replace": "बदलें",
    "action.close": "बंद करें",
    "action.confirm": "पुष्टि करें",
    "action.confirmQuestion": "कार्रवाई की पुष्टि करें?",
    "action.refresh": "ताज़ा करें",
    "action.save": "सहेजें",
    "action.add": "जोड़ें",
    "action.new": "नया",
    "action.import": "आयात करें",
    "action.export": "निर्यात करें",
    "queue.empty": "कोई कतार नहीं",
    "queue.emptyAria": "कतार स्थिति: कोई कतारबद्ध कार्य नहीं",
    "queue.jumpTitle": "सक्रिय कार्यों पर जाएँ",
    "queue.emptyTitle": "कोई कतारबद्ध कार्य नहीं",
    "queue.channel": "चैनल {count}",
    "queue.availableChannels": "उपलब्ध चैनल {usable}/{total}",
    "queue.dispatching": "शेड्यूलिंग · प्रतीक्षा {waiting}",
    "queue.runningWaiting": "चल रहा है {running} · प्रतीक्षा कर रहा है {waiting}",
    "queue.statusLabel": "कतार स्थिति: {text} · {channelText}. सक्रिय कार्यों पर जाने के लिए क्लिक करें",
    "queue.runningActions": "कार्य कतार क्रियाएँ चलाना",
    "queue.waitingActions": "प्रतीक्षारत कार्य कतार क्रियाएँ",
    "queue.cancelRunning": "रद्द करें",
    "queue.cancelRunningTitle": "चल रहा कार्य रद्द करें",
    "queue.dragWaiting": "प्रतीक्षा कार्य को पुन: व्यवस्थित करने के लिए खींचें",
    "queue.dragSort": "क्रमबद्ध करने के लिए खींचें",
    "queue.moveUp": "ऊपर",
    "queue.moveUpTitle": "प्रतीक्षा कार्य को ऊपर ले जाएँ",
    "queue.moveDown": "नीचे",
    "queue.moveDownTitle": "प्रतीक्षा कार्य को नीचे ले जाएँ",
    "queue.promote": "शीर्ष",
    "queue.promoteTitle": "प्रतीक्षा कार्य को शीर्ष पर ले जाएं",
    "queue.promoteFailed": "शीर्ष पर ले जाना विफल रहा",
    "queue.deleteWaitingShort": "हटाएँ",
    "queue.deleteWaitingTitle": "प्रतीक्षा कार्य हटाएँ",
    "queue.deleteWaitingTitleConfirm": "प्रतीक्षा कार्य हटाएं?",
    "queue.deleteWaitingMessage": "यह इसे कतार और इतिहास सूची से हटा देता है।",
    "queue.deleteQueuedFailed": "पंक्तिबद्ध कार्य को हटाने में विफल",
    "queue.queuedDeleted": "कतारबद्ध कार्य हटा दिया गया",
    "queue.cancelRunningConfirm": "कार्य रद्द करें",
    "queue.cancelRunningTitleConfirm": "चल रहा कार्य रद्द करें?",
    "queue.cancelRunningMessage": "वर्तमान कार्य रुक जायेगा. इतिहास रखा जाएगा.",
    "queue.cancelRunningFailed": "कार्य रद्द करने में विफल",
    "queue.runningCancelled": "कार्य रद्द कर दिया गया",
    "queue.reorderFailed": "कतार को पुन: व्यवस्थित करने में विफल",
    "queue.realtimeUpdateFailed": "लाइव स्थिति अपडेट करने में विफल",
    "queue.realtimeDisconnected": "लाइव स्थिति कनेक्शन खो गया था. पुनर्प्राप्त करने के लिए पृष्ठ को ताज़ा करें.",
    "queue.readFailed": "कतार लोड करने में विफल",
    "status.waiting": "प्रतीक्षा में",
    "status.shownActiveTasks": "सक्रिय कार्य दिखा रहा है",
    "status.jsonCopied": "JSON कॉपी किया गया",
    "taskStatus.submitting": "सबमिट करना",
    "taskStatus.running": "जनरेट हो रहा है",
    "taskStatus.runningWithElapsed": "जनरेट हो रहा है · {elapsed}",
    "taskStatus.completed": "पूरा हुआ",
    "taskStatus.partialFailed": "आंशिक रूप से असफल",
    "taskStatus.failed": "असफल",
    "taskStatus.queued": "कतारबद्ध",
    "taskStatus.unknown": "अज्ञात स्थिति",
    "taskStatus.task": "कार्य",
    "taskStatus.connectionInterrupted": "कनेक्शन बाधित",
    "taskStatus.lastFailed": "पिछली बार विफल",
    "taskStatus.waitingRetry": "{reason}, पुनः प्रयास करने की प्रतीक्षा कर रहा है (प्रयास {attempt}/{max})",
    "taskStatus.retrying": "{reason}, पुनः प्रयास कर रहा हूं (प्रयास {attempt}/{max})",
    "taskStatus.nonRetryableAttempt": "प्रयास {attempt}/{max}, पुनः प्रयास योग्य नहीं",
    "taskStatus.manualRetryAvailable": "रुका हुआ; विफल चित्रों को मैन्युअल रूप से पुनः प्रयास किया जा सकता है",
    "taskStatus.waitingRetryShort": "रीट्राई प्रतीक्षा",
    "taskStatus.retryingShort": "रीट्राई हो रहा",
    "taskStatus.nonRetryableShort": "रीट्राई नहीं",
    "taskStatus.manualRetryShort": "मैनुअल रीट्राई",
    "taskStatus.stoppedShort": "रुका हुआ",
    "taskStatus.runtime": "अवधि {duration}",
    "taskStatus.runtimeCompleted": "अवधि {duration} · पूर्ण {time}",
    "taskStatus.completedAt": "पूर्ण {time}",
    "taskCard.count": "{count} चित्र",
    "taskCard.successCount": "सफल {count}",
    "taskCard.failedCount": "विफल {count}",
    "taskCard.runningCount": "{count} बन रहे हैं",
    "taskCard.waitingCount": "प्रतीक्षा {count}",
    "taskCard.textToImageThumb": "टेक्स्ट-से-चित्र कार्य थंबनेल",
    "taskCard.imageToImageThumb": "चित्र-से-चित्र कार्य थंबनेल",
    "taskCard.failedThumb": "कार्य विफल",
    "taskCard.textBadge": "टी",
    "taskMode.edit": "संपादित करें",
    "taskMode.generate": "जनरेट करें",
    "document.generatingQueue": "जनरेट हो रहा है · कतार {total}",
    "document.queuedWaiting": "कतारबद्ध · प्रतीक्षा {count}",
    "runFeedback.editing": "संपादन",
    "runFeedback.generating": "जनरेट हो रहा है",
    "runFeedback.status": "{action} · {elapsed}",
    "footer.archive": "संग्रह",
    "footer.archiveCount": "संग्रह {count}",
    "footer.historyLibrary": "इतिहास",
    "historyLibrary.openFull": "पूर्ण इतिहास पुस्तकालय खोलें",
    "history.documentTitle": "इतिहास - आईलैब जीपीटी कंज्यूर",
    "history.back": "जेनरेटर को लौटें",
    "history.title": "इतिहास",
    "history.loading": "लोड हो रहा है",
    "history.total": "{total} कार्य · {archived} संग्रहीत",
    "history.search": "खोजें",
    "history.searchPlaceholder": "प्रॉम्प्ट या कार्य ID खोजें",
    "history.clear": "साफ़ करें",
    "history.type": "प्रकार",
    "history.allTypes": "सभी प्रकार",
    "history.type.textToImage": "टेक्स्ट से इमेज",
    "history.type.imageToImage": "इमेज से इमेज",
    "history.month": "महीना",
    "history.status": "स्थिति",
    "history.promptMode": "प्रॉम्प्ट प्रोसेसिंग",
    "history.size": "आकार",
    "history.quality": "गुणवत्ता",
    "history.ratio": "अनुपात",
    "history.orientation": "अभिमुखीकरण",
    "history.backend": "बैकएंड",
    "history.provider": "प्रदाता",
    "history.archived": "संग्रहीत",
    "history.all": "सब",
    "history.allMonths": "सभी महीने",
    "history.allStatuses": "सभी स्थितियाँ",
    "history.allPromptModes": "सभी मोड",
    "history.allSizes": "सभी आकार",
    "history.allQualities": "सभी गुण",
    "history.allRatios": "सभी अनुपात",
    "history.ratioOther": "अन्य",
    "history.allOrientations": "सभी झुकाव",
    "history.allBackends": "सभी बैकएंड",
    "history.allProviders": "सभी प्रदाता",
    "history.unarchived": "असंग्रहीत",
    "history.archivedOnly": "संग्रहीत",
    "history.tasksAria": "ऐतिहासिक कार्य",
    "history.taskListTitle": "ऐतिहासिक कार्य",
    "history.browseNewest": "सबसे पहले नवीनतम ब्राउज़ करें",
    "history.view": "देखें",
    "history.grid": "ग्रिड",
    "history.list": "सूची",
    "history.sort": "क्रमबद्ध करें",
    "history.newest": "सबसे पहले नवीनतम",
    "history.oldest": "सबसे पुराना पहला",
    "history.refresh": "ताज़ा करें",
    "history.selectedCount": "{count} कार्य चयनित",
    "history.confirmDelete": "हटाने की पुष्टि करें",
    "history.detail": "कार्य विवरण",
    "history.detailTitle": "इतिहास कार्य",
    "history.closeDetail": "कार्य विवरण बंद करें",
    "history.resizeFilters": "फ़िल्टर साइडबार का आकार बदलें",
    "history.resizeDetail": "विवरण फलक का आकार बदलें",
    "history.detailEmpty": "विवरण देखने के लिए किसी ऐतिहासिक कार्य का चयन करें",
    "history.loadingDetail": "विवरण लोड हो रहा है...",
    "history.loadMore": "और अधिक लोड करें",
    "history.loadingMore": "लोड हो रहा है...",
    "history.noMore": "कोई और कार्य नहीं",
    "history.loadFailed": "लोड विफल रहा. पुनः प्रयास करने के लिए रीफ्रेश करें या स्क्रॉल करते रहें",
    "history.summaryFailed": "सारांश लोड करने में विफल",
    "history.tasksFailed": "कार्य लोड करने में विफल",
    "history.detailFailed": "विवरण लोड करने में विफल",
    "history.noMatches": "कोई मेल खाता कार्य नहीं",
    "history.loadedCount": "{count} लोड किया गया",
    "history.windowNotice": "माउंट की गई सूची {count} कार्यों तक सीमित है; मांग पर आसन्न कार्यों को पुनर्स्थापित करने के लिए ऊपर या नीचे स्क्रॉल करें।",
    "history.selectTask": "कार्य चुनें",
    "history.viewing": "देखना",
    "history.noPreview": "कोई पूर्वावलोकन चित्र नहीं",
    "history.downloadAll": "ZIP डाउनलोड करें",
    "history.downloadImage": "छवि डाउनलोड करें",
    "history.downloadSelected": "चयनित डाउनलोड करें",
    "history.deleteUnselected": "अचयनित हटाएँ",
    "history.confirmDeleteUnselected": "अचयनित हटाये जाने की पुष्टि करें",
    "history.selected": "चयनित",
    "history.select": "चयन करें",
    "history.downloadIndex": "डाउनलोड करें {index}",
    "history.addReference": "संदर्भ जोड़ें",
    "history.outputActions": "परिणाम चित्र क्रियाएँ",
    "history.inputReferences": "इनपुट संदर्भ",
    "history.inputReferenceIndex": "इनपुट संदर्भ {index}",
    "history.copyPrompt": "प्रॉम्प्ट कॉपी करें",
    "history.copyPrompts": "प्रॉम्प्ट कॉपी करें",
    "history.copyPromptShort": "कॉपी",
    "history.copyPromptPanel": "{title} कॉपी करें",
    "history.copyOutputPromptPanel": "चित्र {index} का संशोधित प्रॉम्प्ट कॉपी करें",
    "history.copyTaskIds": "कार्य आईडी कॉपी करें",
    "history.reuseTask": "जनरेटर में देखें",
    "history.downloadTask": "डाउनलोड करें",
    "history.downloadSelectedTasks": "बैच डाउनलोड",
    "history.contextMenuLabel": "इतिहास कार्य संदर्भ मेनू",
    "history.promptCopied": "प्रॉम्प्ट कॉपी किया गया",
    "history.promptsCopied": "{count} कार्यों के प्रॉम्प्ट कॉपी किए गए",
    "history.taskIdsCopied": "{count} कार्य ID कॉपी किए गए",
    "history.promptCopiedShort": "नकल की गई",
    "history.promptCopyFailed": "प्रॉम्प्ट कॉपी करने में विफल",
    "history.promptCopyFailedShort": "असफल",
    "history.noPrompt": "इस कार्य में कॉपी करने के लिए कोई प्रॉम्प्ट नहीं है",
    "history.noPromptShort": "ख़ाली",
    "history.downloadStarted": "डाउनलोड प्रारंभ हुआ",
    "history.batchDownloadStarted": "{count} कार्यों के लिए डाउनलोड प्रारंभ किया गया",
    "history.noDownloadableOutputs": "कोई डाउनलोड करने योग्य चित्र नहीं",
    "history.confirmDeleteSelected": "चयनित डिलीट की पुष्टि करें",
    "history.openPreview": "पूर्वावलोकन खोलें",
    "history.closePreview": "पूर्वावलोकन बंद करें",
    "history.untitled": "शीर्षकहीन",
    "history.promptCompare": "प्रॉम्प्ट तुलना",
    "history.promptOriginal": "मूल प्रॉम्प्ट",
    "history.promptSubmitted": "अनुकूलित प्रॉम्प्ट",
    "history.promptRevised": "संशोधित प्रॉम्प्ट",
    "history.outputRevisedPromptTitle": "चित्र {index} का संशोधित प्रॉम्प्ट",
    "history.outputRevisedPromptNotice": "प्रत्येक चित्र का अपना संशोधित प्रॉम्प्ट होता है, जो उसी चित्र के नीचे दिखता है।",
    "history.promptEmpty": "कोई सामग्री नहीं",
    "history.promptMode.strict": "विश्वसनीय",
    "history.promptMode.original": "मूल पाठ",
    "history.promptMode.off": "स्वचालित",
    "history.quality.high": "उच्च",
    "history.quality.medium": "मध्यम",
    "history.quality.low": "निम्न",
    "history.quality.auto": "ऑटो",
    "footer.batch": "बैच",
    "footer.storage": "भंडारण",
    "footer.apiStatus": "API स्थिति: ठीक है",
    "footer.version": "संस्करण {version}",
    "footer.versionInfo": "संस्करण जानकारी",
    "footer.versionLoading": "संस्करण...",
    "footer.updateBadge": "नया संस्करण उपलब्ध है",
    "footer.updateAvailable": "नया संस्करण {version}",
    "version.title": "संस्करण एवं अद्यतन",
    "version.loading": "संस्करण स्थिति पढ़ना",
    "version.current": "वर्तमान संस्करण",
    "version.latest": "नवीनतम संस्करण",
    "version.source": "रनटाइम",
    "version.sourcePortable": "पोर्टेबल पैकेज",
    "version.sourceStandard": "Standard app",
    "version.sourceSource": "स्रोत चेकआउट",
    "version.upToDate": "आप पहले से ही नवीनतम संस्करण पर हैं",
    "version.updateAvailable": "संस्करण {version} उपलब्ध है. WebUI सर्वर विंडो बंद करें, फिर अपग्रेड करने के लिए अपडेटर चलाएँ।",
    "version.standardUpdateAvailable": "Version {version} is available. Updater-enabled macOS standard apps can install it from Check for Updates in the menu bar; this link remains the manual fallback.",
    "version.standardManualInstall": "Updater-enabled macOS standard apps support user-confirmed replacement; older macOS apps and Windows standard ZIP packages still update manually.",
    "version.noUpdater": "यह रनटाइम एक पोर्टेबल पैकेज नहीं है, इसलिए अपडेटर स्वचालित रूप से प्रारंभ नहीं किया जा सकता है।",
    "version.openUpdater": "अद्यतनकर्ता प्रारंभ करें",
    "version.release": "रिलीज देखें",
    "version.updaterStarted": "अपडेटर प्रारंभ हुआ. वर्तमान WebUI सर्वर विंडो बंद करें, फिर अपडेटर निर्देशों का पालन करें।",
    "version.updaterFailed": "अद्यतनकर्ता प्रारंभ नहीं किया जा सका. अपडेटर स्क्रिप्ट को पैकेज से मैन्युअल रूप से चलाएँ।",
    "version.historyTitle": "नया क्या है",
    "version.historyEmpty": "कोई रिलीज़ नोट उपलब्ध नहीं है",
    "version.currentBadge": "वर्तमान",
    "version.releaseDate": "{date}",
    "version.change.quick_gallery_picker": "Added a quick gallery modal picker with real-time search, multi-selection, and thumbnail optimizations.",
    "version.change.official_asset_library": "आधिकारिक लोगो, स्लोगन और व्यावसायिक हस्ताक्षर लाइब्रेरी में अधिक ब्रांड, व्यवसाय श्रेणियां, क्षैतिज व ऊर्ध्वाधर लेआउट और इनवर्टेड संस्करण जोड़े गए।",
    "version.change.material_picker_modal": "सामग्री चयनकर्ता अब एक संवाद है जिसमें बड़े थंबनेल, श्रेणियाँ, खोज और बहु-चयन उपलब्ध है।",
    "version.change.brand_name": "उत्पाद का नाम बदलकर सभी भाषाओं में AI Innovation Studio कर दिया गया है।",
    "version.change.brand_templates": "चुनने योग्य ब्रांड टेम्पलेट और लोगो, स्लोगन व अन्य तत्वों की स्वचालित रचना जोड़ी गई।",
    "version.change.brand_preview": "ब्रांड परिणाम प्रीव्यू, इतिहास, ज़ूम और डाउनलोड में एकसमान रहते हैं तथा मूल चित्र उपलब्ध रहता है।",
    "version.change.mobile_workspace": "मोबाइल हेडर, एक्शन बार, सामग्री सारांश और खाली प्रीव्यू को अधिक संक्षिप्त बनाया गया।",
    "version.change.task_center": "मोबाइल कार्य केंद्र को संक्षिप्त किया गया और चल रहे व प्रतीक्षारत कार्यों का बैज जोड़ा गया।",
    "version.change.brand_launch": "Hengtai दृश्य सामग्री के साथ ब्रांडेड मोबाइल अनुभव पहली बार जारी किया गया।",
    "version.change.core_workflow": "जनरेशन, कार्य कतार, इतिहास, गैलरी और सेटिंग्स का मूल कार्यप्रवाह उपलब्ध कराया गया।",
    "notifications.title": "सूचनाएं",
    "notifications.unread": "सूचनाएं, {count} अपठित",
    "notifications.unreadSummary": "{count} अपठित",
    "notifications.empty": "कोई कार्य सूचना नहीं",
    "notifications.taskFailed": "कार्य विफल",
    "notifications.taskPartial": "कार्य आंशिक रूप से पूरा हुआ",
    "notifications.taskCompleted": "कार्य पूरा हुआ",
    "notifications.generationFailed": "जनरेशन विफल",
    "notifications.successCount": "{count} सफल हुआ",
    "notifications.resultAvailable": "परिणाम उपलब्ध",
    "notifications.failedCount": "{count} विफल",
    "notifications.systemUnsupported": "यह ब्राउज़र सिस्टम सूचनाओं का समर्थन नहीं करता",
    "notifications.systemBlocked": "सिस्टम सूचनाएं ब्राउज़र द्वारा अवरुद्ध कर दी जाती हैं. उन्हें ब्राउज़र सेटिंग में सक्षम करें.",
    "notifications.systemDenied": "सिस्टम सूचनाएं सक्षम नहीं हैं",
    "notifications.systemEnabled": "सिस्टम सूचनाएं सक्षम की गईं",
    "notifications.taskMissing": "कार्य मौजूद नहीं है या हटा दिया गया है",
    "theme.label": "थीम",
    "theme.system": "ऑटो",
    "theme.light": "लाइट",
    "theme.dark": "डार्क",
    "language.label": "इंटरफ़ेस भाषा",
    "language.zh": "中",
    "language.zhCN": "简体中文",
    "language.zhTW": "正體中文",
    "language.zhHK": "繁体中文",
    "language.ja": "日本語",
    "language.ko": "한국어",
    "language.en": "English",
    "language.es": "Español",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.de": "Deutsch",
    "language.ru": "Русский",
    "language.it": "Italiano",
    "language.hi": "हिन्दी",
    "auth.label": "प्रमाणीकरण स्रोत",
    "auth.checking": "प्रमाणीकरण की जाँच की जा रही है",
    "auth.missingCodexSession": "कोई Codex सत्र नहीं मिला",
    "auth.switchFailed": "प्रमाणीकरण स्रोत स्विच करने में विफल",
    "auth.sourceUnavailable": "{source} अनुपलब्ध",
    "auth.notActive": "सक्रिय नहीं",
    "api.settings": "सिस्टम सेटिंग्स",
    "api.provider": "API प्रदाता",
    "imageInput.title": "चित्र",
    "imageInput.uploadAria": "चित्र और फ़ाइलें जोड़ने के लिए क्लिक करें, ड्रॉप करें या पेस्ट करें",
    "imageInput.uploadFull": "चित्र और फ़ाइलें जोड़ने के लिए क्लिक करें, ड्रॉप करें या पेस्ट करें",
    "imageInput.uploadCompact": "इनपुट जोड़ें",
    "imageInput.uploadSubtitle": "चित्र और Responses संदर्भ फ़ाइलें समर्थित हैं",
    "imageInput.recent": "हाल के अपलोड",
    "imageInput.recentBadge": "हाल का",
    "imageInput.uploadBadge": "अपलोड करें",
    "imageInput.addToGallery": "गैलरी में जोड़ें",
    "imageInput.addToGalleryShort": "गैलरी",
    "imageInput.removeImage": "चित्र हटाएँ",
    "imageInput.editedBadge": "संपादित",
    "imageInput.editImage": "संपादित करें {name}",
    "imageInput.deletedRecent": "हालिया अपलोड हटा दिया गया",
    "imageInput.deletedGallery": "गैलरी चित्र हटाया गया",
    "recentAssets.defaultName": "हालिया अपलोड",
    "recentAssets.use": "{name} का प्रयोग करें",
    "recentAssets.delete": "{name} हटाएं",
    "recentAssets.deleteTitle": "हालिया अपलोड हटाएं?",
    "recentAssets.deleteMessage": "यह हाल के अपलोड से चित्र को हटा देगा। यदि यह अभी चित्र इनपुट के रूप में चुना गया है, तो इसे वर्तमान इनपुट से भी हटा दिया जाएगा। इस हालिया अपलोड का संदर्भ देने वाले पुराने कार्य अपना इनपुट पूर्वावलोकन खो देंगे। सार्वजनिक गैलरी प्रभावित नहीं होगी.",
    "recentAssets.loadFailed": "हाल के अपलोड लोड करने में विफल",
    "recentAssets.deleteFailed": "हालिया अपलोड हटाने में विफल",
    "recentAssets.deleted": "हालिया अपलोड हटा दिया गया",
    "inputSource.uploadFallback": "अपलोड किया गया चित्र",
    "inputSource.galleryFallback": "गैलरी चित्र",
    "inputSource.focusPasteFallback": "{prefix}. चित्र इनपुट सक्रिय है; चित्र चिपकाने के लिए {shortcut} दबाएँ।",
    "inputSource.pastedCount": "{count} क्लिपबोर्ड चित्र चिपकाए गए",
    "inputSource.droppedCount": "{count} ड्रॉप किए गए चित्र जोड़े गए",
    "inputSource.dropImagesOnly": "केवल चित्र फ़ाइलें ड्रॉप करें",
    "inputSource.clipboardUnsupported": "यह ब्राउज़र क्लिपबोर्ड को सीधे नहीं पढ़ सकता है",
    "inputSource.clipboardEmpty": "कोई क्लिपबोर्ड चित्र नहीं मिला",
    "inputSource.clipboardDenied": "ब्राउज़र ने सीधे क्लिपबोर्ड पहुंच को अवरुद्ध कर दिया",
    "inputSource.clipboardReadFailed": "क्लिपबोर्ड पढ़ने में विफल",
    "status.missingGalleryReference": "एक गैलरी संदर्भ चित्र हटा दिया गया है। जनरेट करने से पहले इसे हटा दें.",
    "status.missingRecentReference": "एक हालिया अपलोड संदर्भ चित्र हटा दिया गया है। जनरेट करने से पहले इसे हटा दें.",
    "status.emptyPrompt": "प्रॉम्प्ट दर्ज करें",
    "status.editNeedsImage": "संपादन मोड के लिए कम से कम एक चित्र चाहिए",
    "status.loadedTask": "लोड किया गया कार्य {taskId}",
    "status.reusedTask": "जनरेटर में कार्य {taskId} खोला गया",
    "status.loadingHistoryInputs": "इतिहास के इनपुट चित्र लोड हो रहे हैं...",
    "status.historyInputLoadFailed": "इतिहास का इनपुट चित्र लोड करने में विफल: {url}",
    "referenceCollector.alreadyStaged": "पहले से लंबित संदर्भ में है",
    "referenceCollector.staged": "{count} संदर्भ चित्र लंबित रखे गए",
    "referenceCollector.title": "लंबित संदर्भ · {count}",
    "referenceCollector.addAll": "सभी संदर्भ जोड़ें",
    "referenceCollector.itemFallback": "लंबित संदर्भ",
    "referenceCollector.remove": "लंबित संदर्भ हटाएँ",
    "referenceCollector.cleared": "लंबित संदर्भ साफ़ कर दिए गए",
    "referenceCollector.added": "{count} संदर्भ चित्र जोड़े गए",
    "referenceCollector.addFailed": "लंबित संदर्भ जोड़ने में विफल",
    "referenceCollector.readFailed": "चित्र पढ़ने में विफल: {status}",
    "gallery.quick": "त्वरित गैलरी",
    "gallery.current": "वर्तमान श्रेणी गैलरी",
    "gallery.categories": "गैलरी श्रेणियां",
    "gallery.categoryPortrait": "चित्र",
    "gallery.categoryCharacter": "किरदार",
    "gallery.categoryProduct": "उत्पाद",
    "gallery.categoryPortraitRole": "पोर्ट्रेट संदर्भ",
    "gallery.categoryCharacterRole": "किरदार संदर्भ",
    "gallery.categoryProductRole": "उत्पाद संदर्भ",
    "gallery.referenceRole": "संदर्भ चित्र",
    "gallery.manage": "गैलरी प्रबंधित करें",
    "gallery.loadFailed": "गैलरी लोड करने में विफल",
    "gallery.imageOrderUpdateFailed": "चित्र क्रम अपडेट करने में विफल",
    "gallery.imageOrderUpdated": "चित्र क्रम अपडेट किया गया",
    "gallery.categoryName": "श्रेणी का नाम",
    "gallery.categoryPromptRole": "प्रॉम्प्ट भूमिका",
    "gallery.categorySave": "सहेजें",
    "gallery.categoryDelete": "हटाएँ",
    "gallery.categoryLoadFailed": "श्रेणियां लोड करने में विफल",
    "gallery.categoryNameRequired": "एक श्रेणी का नाम दर्ज करें",
    "gallery.categoryCreateFailed": "श्रेणी जोड़ने में विफल",
    "gallery.categoryCreated": "श्रेणी जोड़ी गई",
    "gallery.categorySaveFailed": "श्रेणी सहेजने में विफल",
    "gallery.categorySaved": "श्रेणी सहेजी गई",
    "gallery.categoryDeleteTitle": "गैलरी श्रेणी हटाएँ?",
    "gallery.categoryDeleteMessage": "इस श्रेणी के चित्र दूसरी श्रेणी में चले जाएंगे। गैलरी चित्र हटाए नहीं जाएंगे.",
    "gallery.categoryDeleteConfirm": "श्रेणी हटाएँ",
    "gallery.categoryDeleteFailed": "श्रेणी हटाने में विफल",
    "gallery.categoryDeletedMigrated": "श्रेणी \"{name}\" हटा दी गई और चित्र माइग्रेट कर दिए गए",
    "gallery.categoryOrderUpdateFailed": "श्रेणी क्रम अद्यतन करने में विफल",
    "gallery.categoryOrderUpdated": "श्रेणी क्रम अद्यतन किया गया",
    "gallery.categoryFallback": "गैलरी श्रेणी",
    "gallery.imageFallback": "गैलरी चित्र",
    "gallery.imageLoadFailed": "यह चित्र लोड करने में विफल",
    "gallery.editImageLoadFailed": "संपादन के लिए यह चित्र लोड करने में विफल",
    "gallery.cannotAddImage": "यह चित्र गैलरी में नहीं जोड़ा जा सकता",
    "gallery.nameRequired": "गैलरी का नाम दर्ज करें",
    "gallery.saveFailed": "गैलरी चित्र सहेजने में विफल",
    "gallery.savedAsReference": "गैलरी में जोड़ा गया और गैलरी संदर्भ पर स्विच किया गया",
    "gallery.renameImage": "गैलरी चित्र का नाम बदलें",
    "gallery.moveToCategory": "श्रेणी में जाएँ",
    "gallery.categoryRequired": "गैलरी श्रेणी चुनें",
    "gallery.promptNoteTitle": "गैलरी संदर्भ नोट",
    "gallery.updateFailed": "गैलरी अपडेट करने में विफल",
    "gallery.selectImageFile": "चित्र फ़ाइल चुनें",
    "gallery.replaceImageFailed": "गैलरी चित्र बदलने में विफल",
    "gallery.replacedImage": "\"{name}\" का स्रोत चित्र बदला गया",
    "gallery.deleteImageTitle": "गैलरी चित्र हटाएँ?",
    "gallery.deleteImageMessage": "ऐतिहासिक कार्य संदर्भ हटाए गए के रूप में दिखाई देंगे.",
    "gallery.deleteFailed": "गैलरी चित्र हटाने में विफल",
    "gallery.deletedSuffix": " (हटाया गया)",
    "gallery.editImageLabel": "गैलरी चित्र संपादित करें",
    "gallery.fieldCategory": "श्रेणी",
    "gallery.fieldPromptNote": "संदर्भ नोट",
    "gallery.fieldName": "नाम",
    "quickGallery.empty": "{category} चित्र नहीं",
    "promptGallery.remove": "@{name} हटाएं",
    "prompt.title": "प्रॉम्प्ट",
    "prompt.editorLabel": "प्रॉम्प्ट",
    "prompt.placeholder": "जिस चित्र को बनाना या संपादित करना चाहते हैं उसका वर्णन करें। गैलरी संदर्भों के लिए @, रंग कोड के लिए # और प्रॉम्प्ट स्निपेट के लिए ~ टाइप करें।",
    "prompt.run": "जनरेट करें",
    "prompt.runEdit": "संपादन प्रारंभ करें",
    "prompt.runTitle": "जनरेट करें (Cmd+Enter)",
    "prompt.runEditTitle": "संपादन प्रारंभ करें (Cmd+Enter)",
    "prompt.findPanel": "प्रॉम्प्ट ढूंढें और बदलें",
    "prompt.findText": "पाठ खोजें",
    "prompt.replaceWith": "से बदलें",
    "prompt.findActions": "खोजें और बदलें",
    "prompt.countZero": "0 मैच",
    "prompt.matchCount": "{count} मेल खाता है",
    "prompt.foundCount": "{count} मिलान मिला",
    "prompt.noMatch": "कोई मेल खाता पाठ नहीं",
    "prompt.replacedCount": "{count} मिलान बदला गया",
    "prompt.closeFind": "ढूँढ़ें और बदलें बंद करें",
    "prompt.recentTemplates": "हाल के टेम्पलेट्स",
    "prompt.manageTemplates": "टेम्प्लेट प्रबंधित करें",
    "promptModel.galleryHeader": "संदर्भ चित्र नोट्स:",
    "promptModel.galleryInstruction": "- संदर्भ चित्र {number}: गैलरी \"{name}\", भूमिका: {role}। प्रॉम्प्ट में @{name} इस चित्र को संदर्भित करता है।{note}",
    "outputSettings.title": "आउटपुट",
    "output.lock.lock": "पैरामीटर लॉक करें",
    "output.lock.unlock": "अनलॉक करके संपादित करें",
    "output.lock.current": "वर्तमान लॉक",
    "output.lock.task": "चुने गए कार्य के पैरामीटर",
    "output.lock.adoptTask": "इस कार्य के पैरामीटर उपयोग करें",
    "output.lock.frame": "फ़्रेम",
    "output.lock.outputCount": "आउटपुट संख्या",
    "output.lock.output": "आउटपुट",
"output.lock.search": "खोज",
    "output.lock.call": "कॉल",
    "output.lock.sheets": "इमेज",
    "output.lock.imageModel": "इमेज मॉडल",
    "output.lock.prompt": "प्रॉम्प्ट",
    "output.lock.fileFormat": "फ़ाइल फ़ॉर्मैट",
    "output.lock.taskHint": "केवल चुने गए कार्य के पैरामीटर दिख रहे हैं; वर्तमान लॉक नहीं बदला है। इन्हें उपयोग करने से सिस्टम चैनल नहीं बदलता।",
    "output.lock.lockedHint": "पैरामीटर तय हैं। संपादन के लिए ऊपर दाईं ओर लॉक आइकन दबाएँ।",
    "output.lock.enabled": "चालू",
    "output.lock.disabled": "बंद",
    "output.mainModel": "मुख्य मॉडल",
    "output.selectMainModel": "मुख्य मॉडल का चयन करें",
    "output.mainModelCustomForInput": "वर्तमान इनपुट के लिए एक कस्टम मॉडल का उपयोग करें",
    "output.apiDirect": "API प्रत्यक्ष",
    "output.apiToolModel": "API छवि निर्माण मॉडल का उपयोग हो रहा है",
    "output.mainModelUnused": "इस अनुरोध के लिए मुख्य मॉडल का उपयोग नहीं किया गया है",
    "output.webSearch": "वेब खोज",
    "output.webSearchToggle": "पर",
    "output.webSearchTitle": "पहले वेब खोजें, फिर इस जनरेशन में उपयोग करें; केवल Codex और API Responses",
    "output.promptMode": "प्रॉम्प्ट प्रोसेसिंग",
    "output.modeOriginal": "मूल पाठ",
    "output.modeStrict": "विश्वसनीय",
    "output.modeCreative": "स्वचालित",
    "output.promptHelp": "प्रॉम्प्ट प्रोसेसिंग समझाएँ",
    "output.promptHelpTitle": "प्रॉम्प्ट प्रोसेसिंग",
    "output.promptHelp.responsesChannel": "Responses · मुख्य मॉडल शामिल",
    "output.promptHelp.imagesChannel": "Images · सीधा जनरेशन",
    "output.promptHelp.responses.original": "मूल पाठ मुख्य मॉडल को भेजता है और इमेज टूल से उसे यथासंभव ज्यों का त्यों रखने को कहता है; revised prompt फिर भी बन सकता है।",
    "output.promptHelp.responses.strict": "मुख्य मॉडल को प्रॉम्प्ट व्यवस्थित या विस्तृत करने देता है, लेकिन विषय, टेक्स्ट, रंग और रचना जैसी अनिवार्य शर्तें सुरक्षित रखता है।",
    "output.promptHelp.responses.automatic": "कोई अतिरिक्त शर्त नहीं जोड़ता; मुख्य मॉडल इमेज टूल बुलाने से पहले अर्थ समझकर अनुकूलित करता है।",
    "output.promptHelp.images.original": "ऐप स्तर के नियम जोड़े बिना मूल पाठ सीधे इमेज API को भेजता है।",
    "output.promptHelp.images.strict": "सभी अनिवार्य शर्तें सुरक्षित रखने के लिए मूल प्रॉम्प्ट के साथ विश्वसनीयता नियम भेजता है।",
    "output.promptHelp.images.automatic": "इमेज API की डिफ़ॉल्ट प्रोसेसिंग का उपयोग करता है और गैलरी संदर्भ की आवश्यक टिप्पणियाँ शामिल रखता है।",
    "output.sizeMode": "आकार मोड",
    "output.sizePreset": "प्रीसेट",
    "output.sizeCustom": "कस्टम",
    "output.orientation": "अभिमुखीकरण",
    "output.square": "चौकोर",
    "output.portrait": "पोर्ट्रेट",
    "output.landscape": "लैंडस्केप",
    "output.resolution": "रिज़ॉल्यूशन",
    "output.pixelSize": "पिक्सेल आकार",
    "output.width": "चौड़ाई",
    "output.height": "ऊंचाई",
    "output.swapSize": "चौड़ाई और ऊंचाई बदलें",
    "output.customSizeHint": "यूनिट पीएक्स · 16-3840 · 16 का गुणक · ≤3:1",
    "output.imageSizeUnavailable": "चित्र आकार उपलब्ध नहीं",
    "output.imageLoadFailed": "चित्र लोड नहीं हो सका",
    "output.customSizeRequired": "चौड़ाई और ऊंचाई दर्ज करें",
    "output.customSizeBounds": "चौड़ाई और ऊंचाई 16-3840 पिक्सल होनी चाहिए",
    "output.customSizeMultiple": "चौड़ाई और ऊँचाई 16 के गुणज होनी चाहिए",
    "output.customSizeRatio": "लंबे-से-छोटे पार्श्व अनुपात 3:1 से अधिक नहीं हो सकता",
    "output.customSizePixels": "कुल पिक्सेल 655,360-8,294,400 होने चाहिए",
    "output.ratioLock": "अनुपात लॉक (वैकल्पिक)",
    "output.customRatio": "कस्टम पहलू अनुपात",
    "output.ratioWidth": "डब्ल्यू",
    "output.ratioHeight": "एच",
    "output.firstImageRatio": "पहले संदर्भ चित्र का अनुपात उपयोग करें",
    "output.useFirstImage": "चित्र से",
    "output.ratioHint": "निःशुल्क आकार के लिए खाली छोड़ें · दोनों को सिंक करने के लिए भरें",
    "output.ratio": "अनुपात",
    "output.quality": "गुणवत्ता",
    "output.qualityAuto": "ऑटो",
    "output.qualityLow": "निम्न",
    "output.qualityMedium": "मध्यम",
    "output.qualityHigh": "उच्च",
    "output.quantity": "संख्या",
    "output.pixelPreview": "आउटपुट पिक्सेल: 1024 x 1024 px",
    "output.pixelPreviewValue": "आउटपुट पिक्सेल: {value}",
    "output.pixelPreviewAuto": "आउटपुट पिक्सेल: auto (OpenAI स्वचालित रूप से चुनता है)",
    "output.format": "प्रारूप",
    "output.compression": "संपीड़न",
    "output.moderation": "मॉडरेशन",
    "preview.title": "पूर्वावलोकन",
    "preview.selectedZero": "0 चयनित",
    "preview.selectedCount": "चयनित {selected}/{total}",
    "preview.downloadSelected": "चयनित डाउनलोड करें",
    "preview.deleteUnselected": "अचयनित हटाएँ",
    "preview.downloadAll": "ZIP डाउनलोड करें",
    "preview.empty": "अभी तक कोई चित्र नहीं",
    "preview.taskFailed": "कार्य विफल",
    "preview.partialFailed": "कुछ चित्र विफल रहे",
    "preview.failedOutput": "चित्र {index} विफल",
    "preview.progressLine": "पूरा {generated} / {total} · बीत गया {elapsed}",
    "preview.failureLine": "पूर्ण {generated} / {total} · विफल {failed}",
    "preview.elapsedLine": "बीत गया {elapsed}",
    "preview.lastError": "अंतिम त्रुटि: {error}",
    "preview.continueGenerating": "जनरेशन जारी रखें",
    "preview.waitingContinue": "जारी रखने की प्रतीक्षा की जा रही है",
    "preview.retryFailed": "विफल चित्रों को फिर से आज़माएँ",
    "preview.acceptSuccesses": "सफल परिणाम स्वीकार करें",
    "preview.generateMode": "जनरेशन",
    "preview.editMode": "संपादित करें",
    "preview.runningTitle": "{mode} चल रहा है",
    "preview.submittingTitle": "कार्य सबमिट करना",
    "preview.queuedTitle": "कार्य कतारबद्ध",
    "preview.submittingDetail": "इनपुट सहेजना और कार्य को कतार में जोड़ना। जनरेशन अपने आप शुरू हो जाएगी.",
    "preview.queuedDetail": "कार्य कतार में है और उपलब्ध चैनल की प्रतीक्षा कर रहा है।",
    "preview.featured": "चयनित",
    "preview.addFeatured": "परिणाम चुनें",
    "preview.selectedFeatured": "चयनित",
    "preview.removeFeatured": "परिणाम अचयनित करें",
    "preview.selectionAdded": "परिणाम चयनित",
    "preview.selectionRemoved": "परिणाम अचयनित",
    "preview.selectionUpdateFailed": "चयन अद्यतन करने में विफल",
    "preview.noUnselectedOutputs": "हटाने के लिए कोई अचयनित चित्र नहीं है",
    "preview.deleteUnselectedTitle": "अचयनित चित्र हटाएँ?",
    "preview.deleteUnselectedMessage": "यह इस कार्य में अचयनित परिणामों की स्थानीय चित्र फ़ाइलें हटा देगा।",
    "preview.deleteUnselectedDetail": "{selected} रखें, {deleted} हटाएं",
    "preview.deleteUnselectedFailed": "अचयनित चित्र हटाने में विफल",
    "preview.deleteUnselectedDone": "अचयनित चित्र हटाए गए",
    "preview.addReference": "संदर्भ जोड़ें",
    "preview.stage": "लंबित रखें",
    "preview.stageReference": "लंबित संदर्भ में रखें",
    "preview.prompt": "प्रॉम्प्ट",
    "preview.download": "डाउनलोड करें",
    "preview.downloadImage": "यह चित्र डाउनलोड करें",
    "lightbox.label": "चित्र पूर्वावलोकन",
    "lightbox.close": "पूर्वावलोकन बंद करें",
    "lightbox.previous": "पिछला चित्र",
    "lightbox.next": "अगला चित्र",
    "promptPopover.title": "प्रॉम्प्ट तुलना",
    "promptPopover.summary": "मूल {original} · अनुकूलित {optimized}",
    "promptPopover.original": "मूल प्रॉम्प्ट",
    "promptPopover.optimized": "अनुकूलित प्रॉम्प्ट",
    "promptPopover.charCount": "{count} वर्ण",
    "promptPopover.empty": "कोई नहीं",
    "promptPopover.notReturned": "वापस नहीं किया गया",
    "promptPopover.noOptimized": "कोई अनुकूलित प्रॉम्प्ट नहीं लौटा",
    "promptPopover.submitted": "सबमिट किया गया प्रॉम्प्ट देखें",
    "promptPopover.close": "प्रॉम्प्ट तुलना बंद करें",
    "promptPopover.copyOptimized": "अनुकूलित प्रॉम्प्ट कॉपी करें",
    "promptPopover.copied": "नकल की गई",
    "taskContext.menuLabel": "कार्य संदर्भ मेनू",
    "taskContext.view": "कार्य देखें",
    "taskContext.copyId": "कार्य कॉपी करें ID",
    "taskContext.copyPrompt": "प्रॉम्प्ट कॉपी करें",
    "taskContext.revealOutput": "आउटपुट फ़ोल्डर खोलें",
    "taskContext.archive": "कार्य संग्रहित करें",
    "taskContext.delete": "कार्य हटाएँ",
    "taskContext.idCopied": "Task ID कॉपी किया गया",
    "taskContext.promptCopied": "प्रॉम्प्ट कॉपी किया गया",
    "taskContext.noPrompt": "इस कार्य में कॉपी करने के लिए कोई प्रॉम्प्ट नहीं है",
    "taskContext.revealFailed": "आउटपुट फ़ोल्डर खोलने में विफल",
    "taskContext.revealOpened": "आउटपुट फ़ोल्डर खोला गया",
    "taskContext.actionFailed": "कार्य कार्रवाई विफल रही",
    "taskActions.group": "कार्य क्रियाएँ",
    "taskActions.deleteTitle": "कार्य हटाएं?",
    "taskActions.deleteMessage": "इससे स्थानीय चित्र फ़ाइलें भी हट जाएंगी.",
    "taskActions.runningCannotDelete": "चल रहे कार्यों को हटाया नहीं जा सकता",
    "taskActions.updated": "कार्य स्थिति अद्यतन की गई",
    "taskActions.archived": "चैट संग्रहीत",
    "taskActions.archiveFailed": "संग्रहित करने में विफल",
    "taskActions.deleted": "कार्य हटा दिया गया",
    "taskActions.deleteFailed": "हटाना विफल",
    "taskActions.noRetryableFailedImages": "इस कार्य में पुनः प्रयास योग्य विफल चित्र नहीं हैं",
    "taskActions.retryFailedOutputsFailed": "विफल चित्रों को फिर से आज़माने में विफल",
    "taskActions.requeuedFailedImages": "विफल चित्र फिर से कतार में डाले गए",
    "taskActions.noAcceptableSuccessImages": "इस कार्य में स्वीकार करने के लिए कोई सफल चित्र नहीं है",
    "taskActions.acceptSuccessesFailed": "सफल परिणाम स्वीकार करने में विफल",
    "taskActions.acceptedSuccesses": "सफल परिणाम स्वीकार किये गये",
    "taskActions.viewedUpdateFailed": "पढ़ने की स्थिति अपडेट करने में विफल",
    "taskActions.failedFallback": "कार्य विफल",
    "taskList.empty": "अभी तक कोई इतिहास नहीं",
    "taskList.selectSession": "चैट चुनें",
    "taskList.unreadUpdate": "अपठित अद्यतन",
    "taskList.viewing": "देखना",
    "taskDerived.usageLimited": "उपयोग सीमित",
    "taskSubmit.requestFailed": "अनुरोध विफल",
    "taskSubmit.queued": "कार्य कतार में जोड़ा गया",
    "taskSubmit.timeout": "बैकएंड द्वारा प्रतिक्रिया देने से पहले कार्य सबमिट करने का समय समाप्त हो गया। यह पुष्टि करने के लिए कतार को ताज़ा करें कि क्या इसे जोड़ा गया था, फिर तय करें कि पुनः प्रयास करना है या नहीं।",
    "taskSubmit.failed": "कार्य प्रस्तुत करना विफल रहा",
    "templates.title": "प्रॉम्प्ट टेम्पलेट",
    "templates.summary": "स्थानीय टेम्पलेट लाइब्रेरी",
    "templates.availableCount": "{count} उपलब्ध टेम्पलेट",
    "templates.noMatch": "कोई मेल खाता टेम्पलेट नहीं",
    "templates.empty": "कोई टेम्पलेट नहीं",
    "templates.favoriteBadge": "पसंदीदा",
    "templates.usageCount": "{count} उपयोग करता है",
    "templates.back": "वापस",
    "templates.edit": "संपादित करें",
    "templates.copy": "कॉपी",
    "templates.insert": "सम्मिलित करें",
    "templates.formTitle": "शीर्षक",
    "templates.formShortTitle": "संक्षिप्त शीर्षक",
    "templates.formCategory": "श्रेणी",
    "templates.formTags": "टैग",
    "templates.formThumbnail": "थंबनेल",
    "templates.formContent": "सामग्री",
    "templates.formNotes": "टिप्पणियाँ",
    "templates.formFavorite": "पसंदीदा",
    "templates.thumbnailClear": "साफ़ करें",
    "templates.thumbnailNone": "कोई भी चयनित नहीं",
    "templates.thumbnailEmpty": "कोई इतिहास थंबनेल नहीं",
    "templates.newCategory": "नई श्रेणी",
    "templates.search": "टेम्प्लेट, टैग या सामग्री खोजें",
    "templates.filter": "टेम्पलेट फ़िल्टर",
    "templates.all": "सब",
    "templates.categoryCommon": "सामान्य",
    "templates.categoryPortrait": "चित्र",
    "templates.categoryProduct": "उत्पाद",
    "templates.categoryRepair": "मरम्मत",
    "templates.categoryPoster": "पोस्टर",
    "templates.categoryEcommerce": "ई-कॉमर्स",
    "templates.favorite": "पसंदीदा",
    "templates.recent": "हाल का",
    "templates.category": "श्रेणियाँ",
    "templates.loadFailed": "प्रॉम्प्ट टेम्पलेट लोड करने में विफल",
    "templates.useStateUpdateFailed": "प्रॉम्प्ट टेम्पलेट उपयोग स्थिति अपडेट करने में विफल",
    "templates.copied": "प्रॉम्प्ट टेम्प्लेट कॉपी किया गया",
    "templates.copyFailed": "प्रॉम्प्ट टेम्पलेट कॉपी करने में विफल",
    "templates.history": "इतिहास",
    "templates.saveFailed": "प्रॉम्प्ट टेम्पलेट सहेजने में विफल",
    "templates.saved": "प्रॉम्प्ट टेम्पलेट सहेजा गया",
    "templates.deleteFailed": "प्रॉम्प्ट टेम्पलेट हटाने में विफल",
    "templates.deleted": "प्रॉम्प्ट टेम्पलेट हटा दिया गया",
    "templates.categoryAddFailed": "टेम्प्लेट श्रेणी जोड़ने में विफल",
    "templates.categoryAdded": "टेम्प्लेट श्रेणी जोड़ी गई",
    "templates.categorySaveFailed": "टेम्प्लेट श्रेणी सहेजने में विफल",
    "templates.categorySaved": "टेम्प्लेट श्रेणी सहेजी गई",
    "templates.categoryDeleteFailed": "टेम्प्लेट श्रेणी हटाने में विफल",
    "templates.categoryDeleted": "टेम्प्लेट श्रेणी हटा दी गई",
    "templates.importFailed": "टेम्प्लेट पैक आयात करने में विफल",
    "templates.importedCount": "आयातित {count} टेम्पलेट",
    "templates.exportFailed": "टेम्प्लेट पैक निर्यात करने में विफल",
    "templates.exported": "टेम्प्लेट पैक निर्यात किया गया",
    "snippets.suggestLabel": "प्रॉम्प्ट स्निपेट पिकर",
    "snippets.saveSelection": "सहेजें",
    "snippets.saveSelectionLabel": "चयनित टेक्स्ट को प्रॉम्प्ट स्निपेट के रूप में सहेजें",
    "snippets.popoverLabel": "प्रॉम्प्ट स्निपेट",
    "snippets.defaultCategory": "सामान्य",
    "snippets.loadFailed": "प्रॉम्प्ट स्निपेट लोड करने में विफल",
    "snippets.remove": "~{tag} हटाएं",
    "snippets.expand": "विस्तार करें",
    "snippets.edit": "संपादित करें",
    "snippets.close": "बंद करें",
    "snippets.editTitle": "स्निपेट संपादित करें",
    "snippets.saveTitle": "स्निपेट सहेजें",
    "snippets.shortTag": "लघु टैग",
    "snippets.title": "शीर्षक",
    "snippets.category": "श्रेणी",
    "snippets.content": "सामग्री",
    "snippets.titlePlaceholder": "डिफ़ॉल्ट रूप से शॉर्ट टैग का उपयोग करता है",
    "snippets.cancel": "रद्द करें",
    "snippets.save": "सहेजें",
    "snippets.saveFailed": "प्रॉम्प्ट स्निपेट सहेजने में विफल",
    "snippets.saved": "प्रॉम्प्ट स्निपेट सहेजा गया",
    "snippets.defaultTag": "सामान्य स्निपेट",
    "colors.white": "सफ़ेद",
    "colors.black": "काला",
    "colors.warmBeige": "गर्म बेज रंग",
    "colors.lightGreen": "हल्का हरा",
    "colors.brandGreen": "ब्रांड हरा",
    "colors.peachOrange": "आड़ू नारंगी",
    "colors.lightBlue": "हल्का नीला",
    "colors.lightPink": "हल्का गुलाबी",
    "colors.loadFailed": "रंग सेटिंग लोड करने में विफल",
    "colors.saveFailed": "रंग सेटिंग सहेजने में विफल",
    "colors.importFailed": "रंग सेटिंग आयात करने में विफल",
    "colors.importedCount": "आयातित {count} रंग",
    "colors.recentSaveFailed": "हाल के रंग सहेजने में विफल",
    "colors.favoriteSaveFailed": "पसंदीदा रंग सहेजने में विफल",
    "colors.favoriteDeleteFailed": "पसंदीदा रंग हटाने में विफल",
    "colors.update": "अद्यतन करें",
    "colors.insert": "सम्मिलित करें",
    "colors.pick": "रंग चुनें",
    "colors.pickShort": "चुनें",
    "colors.hexValue": "रंग का मूल्य",
    "colors.pendingUpdate": "रंग बदल गया. आवेदन करने के लिए अपडेट पर क्लिक करें।",
    "colors.save": "सहेजें",
    "colors.exportPs": "निर्यात करें",
    "colors.importPs": "आयात करें",
    "colors.done": "हो गया",
    "colors.manage": "प्रबंधित करें",
    "colors.favorites": "पसंदीदा रंग",
    "colors.recent": "हाल के रंग",
    "colors.recentLabel": "हाल का",
    "colors.deleteFavorite": "पसंदीदा रंग हटाएं {name}",
    "colors.modify": "रंग संपादित करें",
    "colors.modifyValue": "रंग संपादित करें {value}",
    "colors.removeValue": "रंग हटाएं {value}",
    "taskGroup.today": "आज",
    "taskGroup.yesterday": "कल",
    "taskGroup.last7": "पिछले 7 दिन",
    "taskGroup.older": "पुराना",
    "taskGroup.searchResults": "खोज परिणाम",
    "taskGroup.active": "सक्रिय",
    "taskGroup.running": "चल रहा है",
    "taskGroup.waiting": "प्रतीक्षा में",
    "taskGroup.dispatchPending": "एक उपलब्ध चैनल असाइन किया जा रहा है...",
    "taskGroup.expand": "विस्तृत करें{label}",
    "taskGroup.collapse": "संक्षिप्त करें {label}",
    "taskGroup.buttonLabel": "{label}, {count} कार्य",
    "archive.title": "संग्रह",
    "archive.empty": "कोई संग्रहीत चैट नहीं",
    "archive.count": "{count} संग्रहीत चैट",
    "archive.restore": "पुनर्स्थापित करें",
    "archive.archiveFailed": "संग्रहित करने में विफल",
    "archive.restoreFailed": "पुनर्स्थापना विफल",
    "archive.restored": "चैट बहाल हो गई",
    "archive.archiving": "संग्रहित किया जा रहा है...",
    "archive.restoring": "पुनर्स्थापित किया जा रहा है...",
    "archive.deleting": "हटाया जा रहा है...",
    "archive.restoredCount": "{count} कार्यों को पुनर्स्थापित किया गया",
    "settings.title": "भंडारण",
    "settings.status": "भंडारण पथ सहेजने के बाद WebUI को पुनः आरंभ करें",
    "settings.inputRoot": "इनपुट फ़ोल्डर",
    "settings.outputRoot": "आउटपुट फ़ोल्डर",
    "settings.galleryRoot": "गैलरी फ़ोल्डर",
    "settings.sourceDataRoot": "स्रोत डेटा फ़ोल्डर",
    "settings.language": "इंटरफ़ेस भाषा",
    "settings.languageCopy": "पहली बार शुरू होने पर इंटरफ़ेस आपके ब्राउज़र की भाषा अपनाता है। मैनुअल चयन याद रखे जाते हैं।",
    "settings.notificationsCopy": "कार्य पूर्ण या विफल होने पर सूचित करें। सिस्टम सूचनाएं मैन्युअल रूप से सक्षम होनी चाहिए.",
    "settings.inAppNotification": "इन-ऐप सूचनाएं",
    "settings.systemNotification": "सिस्टम सूचनाएं",
    "settings.save": "सेटिंग्स सहेजें",
    "settings.loadFailed": "सेटिंग्स लोड करने में विफल",
    "settings.saveFailed": "सेटिंग्स सहेजने में विफल",
    "settings.savedRestart": "संग्रहण सेटिंग सहेजी गईं. लागू करने के लिए WebUI को पुनरारंभ करें।",
    "settings.saved": "सहेजा गया",
    "settings.savedRestartStatus": "संग्रहण सेटिंग सहेजी गईं. लागू करने के लिए WebUI को पुनरारंभ करें।",
    "systemSettings.title": "सिस्टम सेटिंग्स",
    "systemSettings.tabsLabel": "सिस्टम सेटिंग्स अनुभाग",
    "systemSettings.apiTab": "API सेटिंग्स",
    "systemSettings.codexTab": "Codex चैनल",
    "systemSettings.languageTab": "भाषा / Language",
    "systemSettings.storageTab": "भंडारण एवं सूचनाएं",
    "languageSettings.instantStatus": "सहेजा गया। तुरंत लागू।",
    "apiSettings.title": "API सेटिंग्स",
    "apiSettings.status": "सहेजी गई सेटिंग्स API मोड में तुरंत लागू होती हैं",
    "apiSettings.codexMode": "Codex चैनल",
    "apiSettings.codexImages": "Image",
    "apiSettings.codexResponses": "Responses",
    "apiSettings.providers": "API प्रदाता",
    "apiSettings.searchProviders": "प्रदाता नाम खोजें",
    "apiSettings.noProviderSearchResults": "कोई मेल खाता प्रदाता नहीं",
    "apiSettings.providerCount": "{count} प्रदाता",
    "apiSettings.provider": "प्रदाता",
    "apiSettings.providerName": "प्रदाता का नाम",
    "apiSettings.actualRequest": "वास्तविक अनुरोध",
    "apiSettings.newProviderAction": "नया प्रदाता",
    "apiSettings.copyProvider": "कॉपी",
    "apiSettings.copyProviderName": "{name} कॉपी",
    "apiSettings.copyProviderStatus": "प्रदाता अपनी सहेजी गई कुंजी के साथ कॉपी किया गया। सहेजने से पहले नाम, मॉडल संपादित करें या कुंजी बदलें।",
    "apiSettings.copyProviderWithoutKeyStatus": "प्रदाता कॉपी किया गया. सहेजने से पहले नाम, मॉडल संपादित करें या API कुंजी जोड़ें।",
    "apiSettings.sortProviders": "क्रमबद्ध करें",
    "apiSettings.finishSortProviders": "हो गया",
    "apiSettings.sortProviderModeStatus": "प्रदाताओं को क्रमबद्ध करना",
    "apiSettings.sortProviderStatus": "प्रदाता क्रम बदल गया. अपने आप सहेजा जा रहा है...",
    "apiSettings.moveProviderUp": "ऊपर",
    "apiSettings.moveProviderDown": "नीचे",
    "apiSettings.moveProviderUpAria": "{provider} को ऊपर ले जाएं",
    "apiSettings.moveProviderDownAria": "{provider} को नीचे ले जाएँ",
    "apiSettings.mode": "अनुरोध मोड",
    "apiSettings.images": "प्रत्यक्ष Image API",
    "apiSettings.responses": "Responses API",
    "apiSettings.modeImagesShort": "प्रत्यक्ष",
    "apiSettings.imageModel": "छवि निर्माण मॉडल",
    "apiSettings.concurrency": "समवर्ती सीमा",
    "apiSettings.concurrencyShort": "समवर्ती",
    "apiSettings.advancedSettings": "उन्नत सेटिंग",
    "apiSettings.concurrencyValue": "समवर्ती {concurrency}",
    "apiSettings.keySaved": "API कुंजी सहेजी गई",
    "apiSettings.keyNotSet": "API कुंजी सेट नहीं है",
    "apiSettings.showApiKey": "API Key दिखाएं",
    "apiSettings.hideApiKey": "API Key छिपाएं",
    "apiSettings.editProvider": "प्रदाता संपादित करें",
    "apiSettings.newProviderTitle": "नया प्रदाता",
    "apiSettings.editHint": "प्रदाता सहेजें इस संपादन को बैकएंड में लिखता है। रद्द करें इसे छोड़ देता है।",
    "apiSettings.finishEditFirst": "पहले वर्तमान प्रदाता संपादन को सहेजें या रद्द करें",
    "apiSettings.newDraftStatus": "प्रदाता बनाया जा रहा है। लागू करने के लिए प्रदाता सहेजें।",
    "apiSettings.editDraftStatus": "प्रदाता संपादित किया जा रहा है। लागू करने के लिए प्रदाता सहेजें।",
    "apiSettings.cancelEdit": "संपादन रद्द करें",
    "apiSettings.saveProvider": "प्रदाता सहेजें",
    "apiSettings.saveSelection": "चयन सहेजें",
    "apiSettings.deleteProviderTitle": "प्रदाता हटाएं?",
    "apiSettings.deleteProviderMessage": "\"{provider}\" हटाएं?",
    "apiSettings.deleteProviderDetail": "यह इसे प्रदाता सूची से हटाता है और बैकएंड में अपने आप सहेजता है।",
    "apiSettings.deleteProviderStatus": "प्रदाता हटा दिया गया. अपने आप सहेजा जा रहा है...",
    "apiSettings.save": "API सेटिंग्स सहेजें",
    "apiSettings.loadFailed": "API सेटिंग्स लोड करने में विफल",
    "apiSettings.savedKeyPlaceholder": "API कुंजी बैकएंड पर सहेजी गई है। इसे बदलने के लिए एक नई कुंजी दर्ज करें।",
    "apiSettings.newProvider": "नया प्रदाता",
    "apiSettings.saving": "सहेजा जा रहा है...",
    "apiSettings.savingStatus": "API सेटिंग्स सहेजी जा रही हैं...",
    "apiSettings.autoSaving": "अपने आप सहेजा जा रहा है...",
    "apiSettings.autoSaved": "अपने आप सहेजा गया",
    "apiSettings.saveFailed": "API सेटिंग सहेजने में विफल",
    "apiSettings.savedSummary": "सहेजा गया · Codex {codex} · API {provider} · {mode} · {model} · समवर्ती {concurrency}",
    "apiSettings.savedShort": "सहेजा गया",
    "apiSettings.savedStatus": "API सेटिंग्स सहेजी गईं",
    "apiSettings.saveFailedShort": "सहेजना विफल",
    "codexSettings.title": "Codex चैनल",
    "codexSettings.status": "स्थानीय Codex साइन-इन के लिए जनरेशन चैनल चुनें",
    "codexSettings.notesLabel": "Codex चैनल नोट्स",
    "codexSettings.imagesTitle": "Codex Image",
    "codexSettings.imagesCopy": "डिफ़ॉल्ट चैनल, जो आकार, गुणवत्ता और संपादन पैरामीटर सीधे पास करता है।",
    "codexSettings.responsesTitle": "Codex Responses",
    "codexSettings.responsesCopy": "वेब खोज टूल की जरूरत वाले वर्कफ़्लो के लिए संगतता चैनल।",
    "codexSettings.current": "वर्तमान",
    "codexSettings.save": "Codex चैनल सहेजें",
    "codexSettings.saveMode": "{mode} सहेजें",
    "imageEditor.title": "इनपुट चित्र संपादित करें",
    "imageEditor.promptHint": "चित्र में हाथ से खींचे गए तीर और निशान केवल निर्देश हैं। उन्हें अंतिम चित्र में न रखें.",
    "imageEditor.inputFallback": "इनपुट चित्र",
    "imageEditor.openFailed": "संपादन के लिए यह चित्र खोलने में विफल",
    "imageEditor.loadForEditFailed": "संपादन के लिए यह चित्र लोड करने में विफल",
    "imageEditor.canvasCreateFailed": "चित्र संपादन कैनवास बनाने में विफल",
    "imageEditor.closedRegionRequired": "पहले एक बंद क्षेत्र बनाने के लिए ब्रश का उपयोग करें",
    "imageEditor.saveFailed": "चित्र संपादन सहेजने में विफल",
    "imageEditor.saved": "संपादित इनपुट चित्र सहेजा गया",
    "imageEditor.uneditable": "यह चित्र संपादित नहीं किया जा सकता",
    "imageEditor.resetDone": "मूल चित्र पर रीसेट किया गया",
    "imageEditor.resetFailed": "मूल चित्र पर रीसेट करने में विफल",
    "imageEditor.subtitle": "क्रॉप करें, ड्रॉ करें, भरें या तीर जोड़ें, फिर नए इनपुट चित्र के रूप में सहेजें",
    "imageEditor.toolbar": "चित्र संपादक टूलबार",
    "imageEditor.tools": "उपकरण",
    "imageEditor.select": "चुनें",
    "imageEditor.brush": "ब्रश",
    "imageEditor.arrow": "तीर",
    "imageEditor.crop": "क्रॉप",
    "imageEditor.fill": "भरें",
    "imageEditor.fillLabel": "पेंट बाल्टी भरें",
    "imageEditor.eraser": "इरेज़र",
    "imageEditor.colors": "रंग",
    "imageEditor.red": "लाल",
    "imageEditor.blue": "नीला",
    "imageEditor.green": "हरा",
    "imageEditor.yellow": "पीला",
    "imageEditor.white": "सफ़ेद",
    "imageEditor.black": "काला",
    "imageEditor.customColor": "कस्टम रंग",
    "imageEditor.stroke": "स्ट्रोक",
    "imageEditor.history": "इतिहास",
    "imageEditor.undo": "पूर्ववत करें",
    "imageEditor.redo": "पुनः करें",
    "imageEditor.reset": "चित्र रीसेट करें",
    "imageEditor.canvas": "चित्र संपादन कैनवास",
    "imageEditor.canvasScope": "कैनवास क्षेत्र",
    "imageEditor.canvasScopeBase": "मूल चित्र",
    "imageEditor.canvasScopeFit": "लेयरों के अनुसार",
    "imageEditor.canvasFitDone": "कैनवास लेयर क्षेत्र के अनुसार हो गया",
    "imageEditor.canvasBaseDone": "कैनवास मूल चित्र क्षेत्र में लौटा",
    "imageEditor.insertImages": "चित्र डालें",
    "imageEditor.layers": "लेयर",
    "imageEditor.layerUp": "ऊपर ले जाएं",
    "imageEditor.layerDown": "नीचे ले जाएं",
    "imageEditor.emptyInsertList": "कोई अन्य इनपुट चित्र नहीं है",
    "imageEditor.selectLayerFirst": "पहले एक लेयर चुनें",
    "imageEditor.baseLayer": "मूल चित्र",
    "gallery.title": "गैलरी",
    "gallery.subtitle": "वर्तमान कार्य के लिए संदर्भ चित्र चुनें",
    "gallery.manageCategories": "श्रेणियां प्रबंधित करें",
    "gallery.categoryManager": "गैलरी श्रेणियां प्रबंधित करें",
    "gallery.categoryManagement": "श्रेणी प्रबंधन",
    "gallery.categoryCopy": "श्रेणियाँ गैलरी में सहेजी जाती हैं; प्रॉम्प्ट भूमिकाएँ बताती हैं कि संदर्भों का उपयोग कैसे किया जाता है।",
    "gallery.newCategoryName": "नई श्रेणी का नाम",
    "gallery.newCategoryRole": "प्रॉम्प्ट भूमिका, उदा. शैली संदर्भ",
    "gallery.addCategory": "श्रेणी जोड़ें",
    "gallery.drawerSubtitle": "वर्तमान श्रेणी: {category}। इसे चित्र इनपुट में जोड़ने के लिए \"उपयोग करें\" पर क्लिक करें।",
    "gallery.emptyCategory": "इस श्रेणी में अभी तक कोई चित्र नहीं है",
    "gallery.dragSort": "क्रमबद्ध करने के लिए खींचें",
    "gallery.dragSortImage": "चित्र {name} को क्रमबद्ध करने के लिए खींचें",
    "gallery.dragSortCategory": "ड्रैग-सॉर्ट श्रेणी {name}",
    "gallery.use": "उपयोग करें",
    "gallery.replace": "बदलें",
    "gallery.rename": "नाम बदलें",
    "gallery.moveCategory": "श्रेणी",
    "gallery.note": "नोट",
    "gallery.delete": "हटाएँ",
    "gallery.uncategorized": "अवर्गीकृत",
    "addGallery.title": "गैलरी में जोड़ें",
    "addGallery.copy": "नाम विश्व स्तर पर अद्वितीय हैं और इन्हें बाद में @name के साथ संदर्भित किया जा सकता है",
    "addGallery.name": "नाम",
    "addGallery.namePlaceholder": "उदाहरण: मिया",
    "addGallery.category": "श्रेणी",
    "addGallery.note": "संदर्भ नोट",
    "addGallery.notePlaceholder": "उदाहरण: केवल चेहरे और बालों का संदर्भ दें, कपड़ों या पृष्ठभूमि का नहीं",
    "addGallery.save": "गैलरी में सहेजें",
    "close.promptTemplates": "प्रॉम्प्ट टेम्प्लेट पैनल बंद करें",
    "close.archive": "संग्रह पैनल बंद करें",
    "close.settings": "स्टोरेज सेटिंग पैनल बंद करें",
    "close.apiSettings": "API सेटिंग पैनल बंद करें",
    "close.systemSettings": "सिस्टम सेटिंग पैनल बंद करें",
    "close.imageEditor": "चित्र संपादक पैनल बंद करें",
    "close.gallery": "गैलरी पैनल बंद करें",
    "close.addGallery": "गैलरी पैनल में जोड़ें बंद करें",
    "close.version": "संस्करण अद्यतन पैनल बंद करें",
    "imageInput.referenceTitle": "संदर्भ इनपुट (वैकल्पिक)",
    "referenceFiles.add": "फ़ाइल जोड़ें",
    "referenceFiles.selected": "संदर्भ फ़ाइलें",
    "referenceFiles.recent": "हाल की फ़ाइलें",
    "referenceFiles.familyPdf": "पृष्ठ + टेक्स्ट",
    "referenceFiles.familySpreadsheet": "स्प्रेडशीट",
    "referenceFiles.familyDocument": "दस्तावेज़",
    "referenceFiles.familyText": "टेक्स्ट",
    "referenceFiles.visualLimit": "PDF के अलावा फ़ाइलों में एम्बेडेड चित्र और चार्ट सुरक्षित नहीं रहते। लेआउट महत्वपूर्ण हो तो PDF में बदलें।",
    "referenceFiles.remove": "{filename} हटाएँ",
    "referenceFiles.switchTitle": "संदर्भ फ़ाइलें हटाएँ?",
    "referenceFiles.switchMessage": "संदर्भ फ़ाइलें केवल Responses के साथ काम करती हैं। Images पर जाने से पहले उन्हें हटाएँ।",
    "referenceFiles.removeAndSwitch": "फ़ाइलें हटाकर बदलें",
    "referenceFiles.requiresResponses": "संदर्भ फ़ाइलों के लिए Responses आवश्यक है",
    "referenceFiles.switchToResponses": "Responses पर जाएँ",
    "referenceFiles.openApiSettings": "API सेटिंग खोलें",
    "referenceFiles.providerMissing": "मूल Responses प्रदाता उपलब्ध नहीं है। API सेटिंग में एक प्रदाता चुनें।",
    "referenceFiles.missing": "फ़ाइल अनुपलब्ध",
    "referenceFiles.loadFailed": "संदर्भ फ़ाइलें लोड नहीं हुईं",
    "referenceFiles.errorEmpty": "संदर्भ फ़ाइल खाली है",
    "referenceFiles.errorUnsupported": "यह संदर्भ फ़ाइल प्रकार समर्थित नहीं है",
    "referenceFiles.errorMismatch": "फ़ाइल की सामग्री और एक्सटेंशन मेल नहीं खाते",
    "referenceFiles.errorInvalid": "संदर्भ फ़ाइल अमान्य है",
    "referenceFiles.errorTooLarge": "हर संदर्भ फ़ाइल 50 MB से छोटी होनी चाहिए",
    "referenceFiles.errorTotalTooLarge": "संदर्भ फ़ाइलों का कुल आकार अधिकतम 50 MB हो सकता है",
    "referenceFiles.errorMissing": "चुनी गई संदर्भ फ़ाइल अनुपलब्ध है",
    "referenceFiles.errorProviderUnsupported": "इस प्रदाता का Responses संदर्भ फ़ाइलों का समर्थन नहीं करता",
    "referenceFiles.responsesEnabled": "Responses सक्षम है",
    "referenceFiles.historyPathMismatch": "इन फ़ाइलों के Responses पथ अलग हैं",
    "history.referenceFiles": "संदर्भ फ़ाइलें",
    "history.downloadReferenceFile": "फ़ाइल डाउनलोड करें",
    "history.readdReferenceFile": "फिर जोड़ें"
};
